import i18n from '../i18n';

// Shared color palette used across the entire app.
// All color pickers (projects, teams, labels, habits, meetings, webhooks, custom fields)
// must reference this list so the UI stays consistent everywhere.

// `name` is read in the app's language each time it is shown.
const color = (key, value) => ({
  key,
  value,
  get name() { return i18n.t(`ui_common.colors.${key}`); },
});

export const APP_COLORS = [
  color('charcoal', '#6B7280'),
  color('red',      '#EF4444'),
  color('orange',   '#F97316'),
  color('amber',    '#F59E0B'),
  color('green',    '#22C55E'),
  color('teal',     '#14B8A6'),
  color('blue',     '#3B82F6'),
  color('indigo',   '#6366F1'),
  color('violet',   '#8B5CF6'),
  color('purple',   '#A855F7'),
  color('pink',     '#EC4899'),
  color('rose',     '#F43F5E'),
];

// Flat array of hex values - convenient for pickers that only need the value
export const APP_COLOR_VALUES = APP_COLORS.map(c => c.value);
